// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./PaymentUtils.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "./RecoilAtomsV2.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./UnifiedHelpersV2.bs.js";
import * as PaymentMethodsRecordV2$OrcaPaymentPage from "../Payments/PaymentMethodsRecordV2.bs.js";

function paymentListLookupNew(paymentMethodListValue, isShowPaypal) {
  var walletsList = [];
  var walletToBeDisplayedInTabs = [
    "mb_way",
    "ali_pay",
    "ali_pay_hk",
    "mobile_pay",
    "we_chat_pay",
    "vipps",
    "twint",
    "dana",
    "go_pay",
    "kakao_pay",
    "gcash",
    "momo",
    "touch_n_go",
    "mifinity"
  ];
  var otherPaymentList = [];
  paymentMethodListValue.paymentMethodsEnabled.forEach(function (item) {
        if (walletToBeDisplayedInTabs.includes(item.paymentMethodType)) {
          otherPaymentList.push(item.paymentMethodType);
          return ;
        }
        if (item.paymentMethodType === "wallet") {
          if (item.paymentMethodSubtype !== "paypal" || isShowPaypal) {
            walletsList.push(item.paymentMethodSubtype);
            return ;
          } else {
            return ;
          }
        }
        if (item.paymentMethodType === "bank_debit") {
          otherPaymentList.push(item.paymentMethodSubtype + "_debit");
          return ;
        }
        if (item.paymentMethodType === "card") {
          otherPaymentList.push("card");
          return ;
        }
        if (item.paymentMethodType === "pay_later") {
          if (item.paymentMethodSubtype !== "klarna") {
            return ;
          }
          var klarnaPaymentMethodExperience = PaymentMethodsRecordV2$OrcaPaymentPage.getPaymentExperienceTypeFromPML(paymentMethodListValue, item.paymentMethodType, item.paymentMethodSubtype);
          var isRedirectExperience = klarnaPaymentMethodExperience.includes("RedirectToURL");
          if (isRedirectExperience) {
            otherPaymentList.push(item.paymentMethodSubtype);
            return ;
          } else {
            return ;
          }
        }
        otherPaymentList.push(item.paymentMethodSubtype);
      });
  return {
          walletsList: Utils$OrcaPaymentPage.removeDuplicate(walletsList),
          otherPaymentList: Utils$OrcaPaymentPage.removeDuplicate(otherPaymentList)
        };
}

function useGetPaymentMethodListV2(paymentOptions, paymentType) {
  var methodslist = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var paymentsList = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentMethodsListV2);
  var optionAtomValue = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var isShowPaypal = optionAtomValue.wallets.payPal === "Auto";
  return React.useMemo((function () {
                var listToUse;
                listToUse = paymentType === "Payment" ? paymentsList : methodslist;
                if (typeof listToUse !== "object") {
                  return [
                          [],
                          [],
                          []
                        ];
                }
                if (listToUse.TAG !== "LoadedV2") {
                  return [
                          [],
                          [],
                          []
                        ];
                }
                var match = paymentListLookupNew(listToUse._0, isShowPaypal);
                var otherPaymentList = match.otherPaymentList;
                var wallets = Utils$OrcaPaymentPage.getWalletPaymentMethod(Utils$OrcaPaymentPage.removeDuplicate(match.walletsList), paymentType);
                var payments = Utils$OrcaPaymentPage.removeDuplicate(Belt_Array.concatMany([
                          paymentOptions,
                          otherPaymentList
                        ]));
                return [
                        wallets,
                        payments,
                        otherPaymentList
                      ];
              }), [
              methodslist,
              paymentType
            ]);
}

function getCreditFieldsRequired(paymentManagementListValue) {
  return paymentManagementListValue.paymentMethodsEnabled.filter(function (item) {
              if (item.paymentMethodType === "card") {
                return item.paymentMethodSubtype === "credit";
              } else {
                return false;
              }
            });
}

function getSupportedCardBrandsV2(paymentsListValue) {
  var cardPaymentMethod = paymentsListValue.paymentMethodsEnabled.find(function (ele) {
        return ele.paymentMethodType === "card";
      });
  if (cardPaymentMethod === undefined) {
    return ;
  }
  var cardNetworks = Core__Option.getOr(cardPaymentMethod.cardNetworks, []);
  var cardNetworkNames = cardNetworks.map(function (ele) {
        return CardUtils$OrcaPaymentPage.getCardStringFromType(ele.cardNetwork).toLowerCase();
      });
  if (cardNetworkNames.length > 0) {
    return cardNetworkNames;
  }
  
}

function getPaymentMethodTypeFromListV2(paymentsListValueV2, paymentMethod, paymentMethodType) {
  return Core__Option.getOr(paymentsListValueV2.paymentMethodsEnabled.find(function (item) {
                  if (item.paymentMethodSubtype === paymentMethodType) {
                    return item.paymentMethodType === paymentMethod;
                  } else {
                    return false;
                  }
                }), UnifiedHelpersV2$OrcaPaymentPage.defaultPaymentMethods);
}

function usePaymentMethodTypeFromListV2(paymentsListValueV2, paymentMethod, paymentMethodType) {
  return React.useMemo((function () {
                return getPaymentMethodTypeFromListV2(paymentsListValueV2, paymentMethod, PaymentUtils$OrcaPaymentPage.getPaymentMethodName(paymentMethod, paymentMethodType));
              }), [
              paymentsListValueV2,
              paymentMethod,
              paymentMethodType
            ]);
}

export {
  paymentListLookupNew ,
  useGetPaymentMethodListV2 ,
  getCreditFieldsRequired ,
  getSupportedCardBrandsV2 ,
  getPaymentMethodTypeFromListV2 ,
  usePaymentMethodTypeFromListV2 ,
}
/* react Not a pure module */
